<script setup lang="ts">
import { provide } from 'vue';

import { PwaInstallBanner } from '@/features/pwa';
import { UserContextKey } from '@/shared/lib';

import { useAuthenticatedLayout } from './authenticated-layout';
import { default as ConnectionStatusBanner } from './ConnectionStatusBanner.vue';
import { useUnreadMessageTitle } from './unread-message-title';

const { sharedUser } = useAuthenticatedLayout();
useUnreadMessageTitle();

provide(UserContextKey, sharedUser);
</script>

<template>
  <slot />

  <ConnectionStatusBanner />

  <PwaInstallBanner />
</template>
